// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".privacy-wrapper h1[data-v-5ecd617a]{color:#595959;font-size:16px;font-weight:700;padding:15px 0;text-align:center}.content-block[data-v-5ecd617a]{padding:10px}@media(min-width:768px){.privacy-wrapper[data-v-5ecd617a]{background-color:#e6e6e6;padding-bottom:100px}.privacy-wrapper h1[data-v-5ecd617a]{font-size:38px;padding:40px 0}.content-block[data-v-5ecd617a]{background-color:#fff;margin:0 auto;max-width:1180px;padding:30px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
